import { render } from "./UserCalendar.vue?vue&type=template&id=05a06d7f"
import script from "./UserCalendar.vue?vue&type=script&lang=js"
export * from "./UserCalendar.vue?vue&type=script&lang=js"

import "./UserCalendar.vue?vue&type=style&index=0&id=05a06d7f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__